var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4448_323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 210
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H209.234V209.24H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4448_323)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4448_323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 210
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.615 0C46.8385 0 0 46.8385 0 104.62C0 162.401 46.8385 209.24 104.615 209.24C162.396 209.24 209.234 162.401 209.234 104.62C209.234 46.8385 162.396 0 104.615 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4448_323)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4448_323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 212,
    height: 211
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.266 -0.974121H-0.401123V209.693H210.266V-0.974121Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4448_323)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4448_323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 210
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H209.234V209.24H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4448_323)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4448_323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 210,
    height: 210
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.615 0C46.8385 0 0 46.8385 0 104.62C0 162.401 46.8385 209.24 104.615 209.24C162.396 209.24 209.234 162.401 209.234 104.62C209.234 46.8385 162.396 0 104.615 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4448_323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H209.234V209.24H0V0Z",
    fill: "black"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4448_323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 49,
    width: 80,
    height: 109
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4792 49.6929H112.932V157.693H33.4792V49.6929Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4448_323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.25 60.0055V147.011C112.25 155.938 101.49 160.49 95.0833 154.255L72.6458 132.453H47.7083C39.8802 132.485 33.5625 126.136 33.5625 118.334V88.7034C33.5625 80.9065 39.8802 74.5575 47.7083 74.5575H72.7292L95.0833 52.7815C101.49 46.5211 112.25 51.0732 112.25 60.0055Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4448_323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 126,
    y: 72,
    width: 53,
    height: 61
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.266 72.3594H178.479V132.359H126.266V72.3594Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4448_323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.948 120.974L144.687 101.636L129.844 83.547C128.859 82.297 127.932 80.6147 127.932 78.7918C127.932 75.1929 130.599 72.4689 134.255 72.4689C137.005 72.4689 138.573 73.5418 140.167 75.6304L152.922 92.62L165.594 75.9481C167.333 73.6877 169.016 72.4429 171.854 72.4429C174.698 72.4429 177.682 74.7033 177.682 78.3543C177.682 80.1825 177.016 81.6877 175.771 83.2814L160.927 101.464L176.583 120.714C177.568 121.958 178.495 123.641 178.495 125.469C178.495 129.063 175.828 131.787 172.177 131.787C169.422 131.787 167.854 130.714 166.26 128.625L152.604 110.708L139.094 128.281C137.354 130.542 135.672 131.787 132.833 131.787C129.99 131.787 127.005 129.526 127.005 125.875C127.031 124.047 127.698 122.542 128.948 120.974Z",
    fill: "#FEC000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.82e412ab90e6dbf3e3fc98c54140221c.svg";
export { ForwardRef as ReactComponent };